namespace Cfnc {
    export interface ICfncRootScope extends angular.IRootScopeService {
        title: string;
    }

    export interface IRouteMediator {
        setRoutingHandlers: () => void;
        breadCrumbs: IRoute[];
    }


    export class RouteMediator implements IRouteMediator {
        static serviceId: string = "routemediator";

        // Define the functions and properties to reveal.
        handleRouteChangeError = false;

        breadCrumbs: IRoute[];

        constructor(
            private $location: angular.ILocationService,
            private $rootScope: ICfncRootScope,
            private Title,
            private config: IConfig,
            private logger: ILogger,
            private $routeParams: angular.route.IRouteParamsService,
            private routes: IRoute[],
            private common: ICommonFactory) {

        }

        setRoutingHandlers() {
            this.updateDocTitle();
            this.handleRoutingErrors();
            this.updateBreadCrumbs();
        }

        handleRoutingErrors() {
            this.$rootScope.$on("$routeChangeError",
                (event, current, previous, rejection) => {
                    if (this.handleRouteChangeError) { return; }
                    this.handleRouteChangeError = true;
                    var msg = "Error routing: " + (current && current.name)
                        + ". " + (rejection.msg || "");
                    this.logger.logWarning(msg, current, RouteMediator.serviceId, true);
                    this.$location.path("/");
                });
        }

        updateDocTitle() {
            var self = this;
            self.$rootScope.$on("$routeChangeSuccess",
                (event, current, previous) => {

                    this.handleRouteChangeError = false;
                    var title = this.config.docTitle + " " + (this.common.interpolateTitle(current.title) || "");
                    this.Title.value(title);
                    this.Title.store(true);
                    this.Title.original(title);
                });
        }

        updateBreadCrumbs() {
            this.$rootScope.$on("$routeChangeSuccess",
                (event, current, previous) => {
                    this.breadCrumbs = [];

                    var route = this.routes.filter(r => r.url == current.$$route.originalPath)[0];

                    this.breadCrumbs.push(route);

                    while (route) {
                        var routes = this.routes.filter(r => r.config.settings.breadCrumb != null && r.config.settings.breadCrumb == route.config.settings.parent)
                        if (routes.length > 0) {
                            route = routes[0];
                            this.breadCrumbs.unshift(routes[0]);
                        }
                        else {
                            route = null;
                        }
                    }

                    this.breadCrumbs.unshift({
                        url: this.config.umbracoUrl,
                        config: {
                            title: "Home",
                            templateUrl: null,
                            settings: {}
                        }
                    });
                });
        }


        //interpolateTitle(title: string) {
        //    if (title.indexOf(":") > -1) {
        //        var params = title.match(/\:([a-zA-Z0-9])+/g);
        //        params.forEach((v) => title = title.replace(v, this.$routeParams[v.substr(1)]));
        //    }
        //    return title;
        //};

    }


    angular.module("app").factory(RouteMediator.serviceId, ["$location", "$rootScope", "Title", "config", "logger", "$routeParams", "routes", "common",
        ($location, $rootScope, Title, config, logger, $routeParams, routes, common) =>
            new RouteMediator($location, $rootScope, Title, config, logger, $routeParams, routes, common)
    ]);
}